﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import dummy from '../../app/plugins';

//No internet
require('typeahead-addresspicker');

import tpl_custom from './tpl/custom.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';

import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import helper_createWebpage from '../../helper/createWebpage';
import config from '../../../common/config';
import Help from '../../helper/help';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import EventUpdate from '../../helper/eventUpdate';
import View_CustomHeader from '../region/customHeader/customHeader';


export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_custom({ model: this.model.toJSON() });
    },
    attributes: function () {
        return {
            style: "margin-top: -25px !important;",
        }
    },
    initialize: function () {
        var self = this;

        this.app = this.options.app;

        this.informationCollection = new Entities_Empty.Collection();

        this.createDefaultQRCodeExeceute = false;        
        this.createDefaultSetting = false;        
        
        this.setHasChanged(false);
        this.oldModel = this.model.clone();

        var userChannel = Backbone.Radio.channel('app');
        this.listenTo(userChannel, 'customHeader:iconSave', function () {
            self.btnSubmitClick();
        });
        this.listenTo(userChannel, 'customHeader:iconBack', function () {
        });
    },
    help: function () {
        Help.help(this, true, 'custom');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        this.btnSubmitClick();
        callback();
    },
    cancelHasChanged : function() {
        this.model.attributes = this.oldModel.attributes;
    },
    modelHasChanged : function () {
        var changes = false;

        this.setModel();

        //If culture has change do not ask to save when goes to another menu item
        if (//(this.model.attributes.FirstName == this.oldModel.attributes.FirstName) &&
            //(this.model.attributes.SecondName == this.oldModel.attributes.SecondName) &&
           // (this.model.attributes.Organisation == this.oldModel.attributes.Organisation) &&
            //(this.model.attributes.CompanyRegistration == this.oldModel.attributes.CompanyRegistration) &&
            (this.model.attributes.Name == this.oldModel.attributes.Name) &&
            (this.model.attributes.Email == this.oldModel.attributes.Email) &&
            (this.model.attributes.Address01 == this.oldModel.attributes.Address01) &&
            (this.model.attributes.ContactPersonName == this.oldModel.attributes.ContactPersonName) &&
            (this.model.attributes.ContactPersonPhone == this.oldModel.attributes.ContactPersonPhone) &&
            (this.model.attributes.ContactPersonEmail == this.oldModel.attributes.ContactPersonEmail)) {
            changes = false;
            //this.btnSubmitClick();
        } else if (//(this.model.attributes.FirstName != this.oldModel.attributes.FirstName) ||
            //(this.model.attributes.SecondName != this.oldModel.attributes.SecondName) ||
            (this.model.attributes.Name != this.oldModel.attributes.Name) &&
            (this.model.attributes.Email != this.oldModel.attributes.Email) &&
            (this.model.attributes.Address01 != this.oldModel.attributes.Address01) &&
            (this.model.attributes.ContactPersonName != this.oldModel.attributes.ContactPersonName) &&
            (this.model.attributes.ContactPersonPhone != this.oldModel.attributes.ContactPersonPhone) &&
            (this.model.attributes.ContactPersonEmail != this.oldModel.attributes.ContactPersonEmail)) {
            changes = true;
        }

        this.setHasChanged(changes);
    },
    test: function () {
        this.informationCollection.reset();
        
        var tmpModel = new this.informationCollection.model({ Information: "TEST" });
        this.informationCollection.add(tmpModel);
        this.informationCollection.trigger('change');
    },
    test2: function () {
        this.informationCollection.reset();

        var tmpModel = new this.informationCollection.model({ Information: "TEST" });
        this.informationCollection.add(tmpModel);
        this.informationCollection.trigger('change');
    },
    regions: {
        information: "#customInformation",
        customHeader: "#customHeader"
    },
    onBeforeShow: function () {
        this.information.show(new View_Information({ collection: this.informationCollection, app: this.app }));

        var customHeaderModel = new Entities_Empty.Model();
        customHeaderModel.attributes.Title = resources.X100232;
        customHeaderModel.attributes.Name = "";
        customHeaderModel.attributes.ShowSave = true;
        customHeaderModel.attributes.ShowBack = false;

        this.customHeader.show(new View_CustomHeader({ app: this.app, model: customHeaderModel }));
    },
    ui: {
        'custom_btnSubmit': '#custom_btnSubmit',
        'custom_btnChangePassword' : '#custom_btnChangePassword',
        'custom_btnGoogle': '#custom_btnGoogleFind',
        'custom_inputAddress': '#custom_inputAddress',
        'custom_labelFirstName' : '#custom_labelFirstName',
        'custom_inputFirstName': '#custom_inputFirstName',
        'custom_inputSecondName': '#custom_inputSecondName',
        'custom_inputPhone': '#custom_inputPhone',
        'custom_inputAddressSupplement': '#custom_inputAddressSupplement',
        'test': '#test',
        'help': '#help',
        'customQRCodeInsert_qrCodeContainer': '#customQRCodeInsert_qrCodeContainer',
        'customQRCodeInsert_container': '#customQRCodeInsert_container',
        'customQRCodeInsert_qrCodeLogo': '#customQRCodeInsert_qrCodeLogo',
        'custom_btnPrivate' : '#custom_btnPrivate',
        'custom_btnCompany' : '#custom_btnCompany',
        'custom_btnSociety' : '#custom_btnSociety',
        'custom_iPrivate' : '#custom_iPrivate',
        'custom_iCompany' : '#custom_iCompany',
        'custom_iSociety' : '#custom_iSociety',
        'custom_divCompanyRegistration' : '#custom_divCompanyRegistration',
        'custom_inputCompanyRegistration' : '#custom_inputCompanyRegistration',
        'custom_divAttPerson' : '#custom_divAttPerson',
        'custom_inputAttPerson' : '#custom_inputAttPerson',
    },
    events: {
        'click #custom_btnSubmit': 'btnSubmitClick',
        'click #custom_btnChangePassword': 'btnChangePassword',
        'click #custom_btnGoogleSubmit': 'btnGoogleFind',
        'click @ui.custom_btnPrivate': 'btnPrivateClick',
        'click @ui.custom_btnCompany': 'btnCompanyClick',
        'click @ui.custom_btnSociety': 'btnSocietyClick',
        'click #test': 'test2',
        'click #help': 'help'
    },
    onRender: function () {
        var self = this;
        //this.renderInformation();
        this.setupMenu();
    },
    customViewEvent_setActive: function () {
        var array = [];

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('customViewEvent:setActive', array);
    },
    onAttach(){
        var self = this;

        this.customViewEvent_setActive();

        this.btnAddCheck();
        
        //No internet
        /*this.addressPicker = new AddressPicker();
        this.ui.custom_inputAddress.typeahead(null, {
            displayKey: 'description',
            source: self.addressPicker.ttAdapter()
        });*/

        /*this.addressPicker.bindDefaultTypeaheadEvent(this.ui.custom_inputAddress);
        $(this.addressPicker).on('addresspicker:selected', function (event, parsedGeocodeResult) {
            var _parsedGeocodeResult = self._parseGeocodeResult(parsedGeocodeResult.placeResult);

            if (_parsedGeocodeResult.type != "street_address") {
            }
            else {
                self.setModel(_parsedGeocodeResult);
            }
            self.updateInformationCollection();
        });*/

        //var callback_qrcode_finish = function () {
        //    EventUpdate.checkVersion(self);
        //}

        //if (this.app.entities.collections.customQRCode.fullCollection.length == 0 && !this.createDefaultQRCodeExeceute) {
        //    this.createDefaultQRCodeExeceute = true;
        //    this.createDefaultQRCode(callback_qrcode_finish);
        //} else {
        //    callback_qrcode_finish();
        //}

        
    },
    onDestroy(){
        $(this.addressPicker).unbind();
    },
    renderInformation: function () {
        this.informationCollection.reset();

        //No customYet yet
        if (this.model.validateNoBackbone(this.model.attributes)) {
            var tmpModel = new this.informationCollection.model({ toastType: 3, header: resources.X100229, Information: resources.X100333 });
            this.informationCollection.add(tmpModel);
        }

        //Address is wrong
        /*if (this.model.attributes.Address_lat == 0 || this.model.attributes.Address_lat == 0 ||
            this.model.attributes.Address_lat == null || this.model.attributes.Address_lat == null) {
            var tmpModel = new this.informationCollection.model({ toastType: 3, header: resources.X100229, Information: resources.X100287 });
            this.informationCollection.add(tmpModel);
        }*/

        this.app.renderInformation({ informationCollection: this.informationCollection});
    },
    updateInformationCollection: function () {
        this.renderInformation();
        this.informationCollection.trigger('change');
    },
    btnPrivateClick: function (event) {
        event.preventDefault();
        
        this.model.attributes.Organisation = 0;
        this.btnAddCheck();
    },
    btnCompanyClick: function (event) {
        event.preventDefault();

        this.model.attributes.Organisation = 1;
        this.btnAddCheck();
    },
    btnSocietyClick: function (event) {
        event.preventDefault();

        this.model.attributes.Organisation = 2;
        this.btnAddCheck();
    },
    btnRemoveCheck : function () {
        this.ui.custom_iPrivate.removeClass('fa-check-square');
        this.ui.custom_iCompany.removeClass('fa-check-square');
        this.ui.custom_iSociety.removeClass('fa-check-square');
        this.ui.custom_iPrivate.addClass('fa-square');
        this.ui.custom_iCompany.addClass('fa-square');
        this.ui.custom_iSociety.addClass('fa-square');
    },
    btnAddCheck : function () {
        
        this.btnRemoveCheck();

        var element = '#custom_iPrivate';
        switch (this.model.attributes.Organisation) {
            case 0 : element = '#custom_iPrivate'; break;
            case 1 : element = '#custom_iCompany'; break;
            case 2 : element = '#custom_iSociety'; break;
        }
        $(element).addClass('fa-check-square');

        var text = '';

        var showCompanyRegistration = false;
        switch (element) {
            case '#custom_iPrivate' : text = resources.X100577; showCompanyRegistration = false; break;
            case '#custom_iCompany' : text = resources.X100578; showCompanyRegistration = true; break;
            case '#custom_iSociety' : text = resources.X100579; showCompanyRegistration = false; break;
        }

        var showAttPerson = false;
        switch (element) {
            case '#custom_iPrivate' : showAttPerson = false; break;
            case '#custom_iCompany' : showAttPerson = true; break;
            case '#custom_iSociety' : showAttPerson = true; break;
        }
        
        this.ui.custom_labelFirstName.text(text);

        if (showCompanyRegistration) {
            this.ui.custom_divCompanyRegistration.show();
        } else {
            this.ui.custom_divCompanyRegistration.css('display', 'none');
        } 

        if (showAttPerson) {
            this.ui.custom_divAttPerson.show();
        } else {
            this.ui.custom_divAttPerson.css('display', 'none');
        } 

    },
    setupMenu : function () {
        this.updateInformationCollection();

        var userChannel = Backbone.Radio.channel('app');

        if (this.app.entities.models.custom.getMenuStatus()) {
            userChannel.trigger('customMenu:enable');
        }
        else {
            userChannel.trigger('customMenu:disable');
        }
    },
    btnSubmitClick: function (event) {
        if (event != null) {
            event.preventDefault();
        }

        if (this.setModel()) {
            this.save();
        }
    },
    btnChangePassword : function (event) {
        window.app.router.navigate("#customCrediential");
        window.app.router.customCrediential();

        //var url = config.webApiUrl() + '/Manage';
        //window.location.href = url;
    },
    setModel: function (parsedGeocodeResult) {
        var administrative_area_level_1 = '';
        var administrative_area_level_2 = '';
        var administrative_area_level_3 = '';
        var country = '';
        var lat = 0;
        var lng = 0;
        var locality = '';
        var postal_code = '';
        var route = '';
        var street_number = '';
        var sublocality = '';

        if (parsedGeocodeResult) {
            if (parsedGeocodeResult.administrative_area_level_1 != false) {
                administrative_area_level_1 = parsedGeocodeResult.administrative_area_level_1;
            }
            if (parsedGeocodeResult.administrative_area_level_2 != false) {
                administrative_area_level_2 = parsedGeocodeResult.administrative_area_level_2;
            }
            if (parsedGeocodeResult.administrative_area_level_3 != false) {
                administrative_area_level_3 = parsedGeocodeResult.administrative_area_level_3;
            }
            if (parsedGeocodeResult.country != false) {
                country = parsedGeocodeResult.country;
            }
            if (parsedGeocodeResult.lat != false) {
                lat = parsedGeocodeResult.lat;
            }
            if (parsedGeocodeResult.lng != false) {
                lng = parsedGeocodeResult.lng;
            }
            if (parsedGeocodeResult.locality != false) {
                locality = parsedGeocodeResult.locality;
            }
            if (parsedGeocodeResult.postal_code != false) {
                postal_code = parsedGeocodeResult.postal_code;
            }
            if (parsedGeocodeResult.route != false) {
                route = parsedGeocodeResult.route;
            }
            if (parsedGeocodeResult.street_number != false) {
                street_number = parsedGeocodeResult.street_number;
            }
            if (parsedGeocodeResult.sublocality != false) {
                sublocality = parsedGeocodeResult.sublocality;
            }

            this.model.set({
                FirstName: this.ui.custom_inputFirstName.val(),
                SecondName: '',//this.ui.custom_inputSecondName.val(),
                Organisation : this.model.attributes.Organisation,
                CompanyRegistration: this.ui.custom_inputCompanyRegistration.val(),
                AttPerson : this.ui.custom_inputAttPerson.val(),
                EanNumber : '',
                CultureName: config.cultureName(),
                Phone: this.ui.custom_inputPhone.val(),
                Address: this.ui.custom_inputAddress.val(),
                AddressSupplement: this.ui.custom_inputAddressSupplement.val(),
                Address_administrative_area_level_1: administrative_area_level_1,
                Address_administrative_area_level_2: administrative_area_level_2,
                Address_administrative_area_level_3: administrative_area_level_3,
                Address_country: country,
                Address_lat: lat,
                Address_lng: lng,
                Address_locality: locality,
                Address_postal_code: postal_code,
                Address_route: route,
                Address_street_number: street_number,
                Address_sublocality: sublocality
            });
        }
        else {
            this.model.set({
                FirstName: this.ui.custom_inputFirstName.val(),
                SecondName: '',//this.ui.custom_inputSecondName.val(),
                Organisation : this.model.attributes.Organisation,
                CompanyRegistration: this.ui.custom_inputCompanyRegistration.val(),
                AttPerson : this.ui.custom_inputAttPerson.val(),
                EanNumber : '',
                CultureName: config.cultureName(),
                Phone: this.ui.custom_inputPhone.val(),
                Address: this.ui.custom_inputAddress.val(),
                AddressSupplement: this.ui.custom_inputAddressSupplement.val(),
            });
        }

        $('#loginPartialdisplayName').text(resources.X100278 + ' ' + this.model.attributes.FirstName + '!');

        return true;
    },
    save: function () {
        var self = this;

        this.hideErrors();

        var ret = this.model.validateNoBackbone(this.model.attributes);
        if (ret == false) {

            var dialogWaitingModel = new Entities_Empty.Model();
            dialogWaitingModel.attributes.Title = resources.X100232;
            dialogWaitingModel.attributes.Text = resources.X100409;
            dialogWaitingModel.attributes.Button = resources.X100279;

            var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
            var callback = function (options) {
                self.stopListening(dialogWaiting, "dialog:okclicked", callback);
            }
            this.listenTo(dialogWaiting, "dialog:okclicked", callback);
            this.app.dialogRegion.show(dialogWaiting);

        
            this.model.save(this.model.attributes, {
                success: function () {
                    dialogWaiting.triggerMethod('dialog:close');
                    self.setupMenu();
                    self.oldModel = self.model.clone();

                    localStorage.setItem('events4usUser_FirstName',self.app.entities.models.custom.attributes.FirstName);
                    localStorage.setItem('events4usUser_AttPerson',self.app.entities.models.custom.attributes.AttPerson);
                    localStorage.setItem('events4usUser_Organisation',self.app.entities.models.custom.attributes.Organisation);

                    var userChannel = Backbone.Radio.channel('app');
                    userChannel.trigger('Region_Header:setLoginName');
                }
            });
        } else  {
            this.showErrors(this.model.errors);
        }
    },
    _parseGeocodeResult: function (geocodeResult) {
        this._addressParts = {
            street_number: null, route: null, locality: null, sublocality: null,
            administrative_area_level_3: null, administrative_area_level_2: null,
            administrative_area_level_1: null, country: null, postal_code: null, type: null
        };

        this._parseLatAndLng = function (location) {
            var longitude, latitude;

            if (typeof (location.lat) === 'function') {
                latitude = location.lat();
                longitude = location.lng();
            } else {
                latitude = location.lat;
                longitude = location.lng;
            }

            return { lat: latitude, lng: longitude };
        };

        this._findInfo = function (result, type) {
            for (var i = 0; i < result.address_components.length; i++) {
                var component = result.address_components[i];
                if (component.types.indexOf(type) != -1) {
                    return component.long_name;
                }
            }
            return false;
        };

        var parsed = this._parseLatAndLng(geocodeResult.geometry.location);

        for (var addressPart in this._addressParts) {
            parsed[addressPart] = this._findInfo(geocodeResult, addressPart);
        }

        parsed.type = geocodeResult.types[0];

        return parsed;
    },
    createDefaultQRCode: function (callback_qrcode_finish) {
        var self = this;

        this.hideErrors();
        var tmpModel = new this.app.entities.collections.customQRCode.model();
        //tmpModel.attributes.id = null;
        tmpModel.attributes.AuthUserId = config.authUserId();
        tmpModel.attributes.Name = resources.X100123;
        tmpModel.attributes.Render = "canvas";
        tmpModel.attributes.EcLevel = "H";
        tmpModel.attributes.MinVersion = 6;
        tmpModel.attributes.Fill = "Rgb(0,0,0)";
        tmpModel.attributes.Background = "Rgb(255,255,255)";
        tmpModel.attributes.Text = resources.X100068;
        tmpModel.attributes.Size = 300;
        tmpModel.attributes.Radius = 0;
        tmpModel.attributes.Quiet = 1;
        tmpModel.attributes.Mode = 3;
        tmpModel.attributes.MSize = 11;
        tmpModel.attributes.MPosX = 50;
        tmpModel.attributes.MPosY = 50;
        tmpModel.attributes.Label = "Events4us";
        tmpModel.attributes.FontName = "Arial,Arial,Helvetica,sans-serif";
        tmpModel.attributes.FontColor = "Rgb(255,0,0)";
        tmpModel.attributes.FontStyle = 0;
        tmpModel.attributes.FontSize = "30px";
        tmpModel.attributes.Logo = "/images/Events4us.png";

        this.ui.customQRCodeInsert_container.empty();

        this.hideErrors();

        var ret = tmpModel.validateNoBackbone(app);
        if (ret == false) {
            var dialogWaitingModel = new Entities_Empty.Model();
            dialogWaitingModel.attributes.Title = resources.X100071;
            dialogWaitingModel.attributes.Text = resources.X100307;
            dialogWaitingModel.attributes.Button = resources.X100279;

            var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
            var callback = function (options) {
                dialogWaiting.triggerMethod('dialog:close');
                self.stopListening(dialogWaiting, "dialog:okclicked", callback);
                callback_qrcode_finish();
            }
            this.listenTo(dialogWaiting, "dialog:okclicked", callback);
            this.app.dialogRegion.show(dialogWaiting);

            this.ui.customQRCodeInsert_qrCodeLogo.load(function () {
                var tmpModelQRCode = new Entities_Empty.Model();
                //tmpModelQRCode.attributes.id = -1;

                tmpModelQRCode = helper_createWebpage.createQRCodeImage(tmpModel, tmpModelQRCode, self.ui.customQRCodeInsert_qrCodeLogo, self.ui.customQRCodeInsert_qrCodeContainer, false, self.app);
                tmpModel.attributes.ImageData = tmpModelQRCode.attributes.ImageData;
                tmpModel.attributes.ImageMimeType = tmpModelQRCode.attributes.ImageMimeType;
                tmpModel.attributes.ImageUpdate = tmpModelQRCode.attributes.ImageUpdate;
                tmpModel.attributes.Filename = tmpModel.attributes.Name + '_' + new Date().getTime() + '.jpg';

                self.ui.customQRCodeInsert_container.empty();
                self.ui.customQRCodeInsert_qrCodeLogo.off("load");

                self.app.entities.collections.customQRCode.fullCollection.create(tmpModel, {
                    success: function (response) {
                        dialogWaiting.triggerMethod('dialog:okclicked');
                    }
                }, self.app);
            });
            this.ui.customQRCodeInsert_qrCodeLogo.attr("src", tmpModel.attributes.Logo);
        } else  {
            this.showErrors(tmpModel.errors);
        }
    }
}, Backbone.Radio.Requests);
